import { Bell } from "lucide-react";
import { useTranslation } from "react-i18next";

export function NotificationEmpty() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center px-6 py-30 min-h-full">
      <div className="size-20 rounded-full bg-muted flex items-center justify-center mb-4">
        <Bell className="size-8 text-muted-foreground" />
      </div>
      <h2 className="text-lg font-semibold mb-1">
        {t("notifications.empty.title", "No notifications")}
      </h2>
      <p className="text-sm text-muted-foreground text-center">
        {t(
          "notifications.empty.description",
          "You're all caught up! New notifications will appear here.",
        )}
      </p>
    </div>
  );
}
